/* CUSTOM_DEALIDENTITY_BY_CLAUDE (Ryan 2026-09-10)
   ─────────────────────────────────────────────────────────────────────────────
   Settings → Admin: One Customer, One Deal — the JS half.

   ⛔ ITS OWN ASSET BECAUSE THE SECTION IS FULL. rep-quote-settings.liquid sits within a few KB of
   Shopify's 256 KB template limit, so the markup lives in
   snippets/rep-settings-deal-identity.liquid and this runs from here — the same split
   rep-settings-agent-panels.js took in 2026-09-04, and the rule for anything added to this page
   from now on.

   ⛔ NOTHING IS DEFAULTED IN THE MARKUP. Every field is filled from GET
   /admin/deal-identity-config, because a number typed into the HTML would read as the live
   setting whether or not the worker agreed — and these three govern lead ROUTING, where being
   quietly wrong is the whole failure mode. A failed load leaves the fields empty and says so.

   ⚠️ THE SAVE POSTS ONLY WHAT THIS PANEL OWNS, and the worker merges it over the stored record
   rather than over its defaults — so a future panel editing one field of this config cannot reset
   the other two. See writeIdentityConfig in the worker's lib/deal-identity.js.

   Loaded deferred from the section, after custom-rep-portal.js (which defines
   window.RepPortal.API); runs on DOMContentLoaded, by which point every deferred script has run.
   showMsg / hideMsg are the section's two helpers, copied because they are IIFE-local there. */
(function() {
  'use strict';

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }

  function initDealIdentityPanel() {
    if (!window.RepPortal || !window.RepPortal.API) return;

    var enabled = document.getElementById('settings-dealid-enabled');
    var fold = document.getElementById('settings-dealid-fold');
    var join = document.getElementById('settings-dealid-join');
    var coldOn = document.getElementById('settings-cold-enabled');
    var coldDays = document.getElementById('settings-cold-days');
    var btn = document.getElementById('settings-dealid-btn');
    var msg = document.getElementById('settings-dealid-msg');
    if (!enabled || !fold || !join || !btn) return;   // not an admin, or the snippet is absent

    /* A window of 0 means "this tier is off", which is a real setting — so an empty field and a
       zero must never be confused. `''` is "the user cleared it", and the save refuses it rather
       than sending a 0 nobody chose. */
    function readWindow(el, max, label) {
      var raw = String(el.value == null ? '' : el.value).trim();
      if (raw === '') return { error: 'Enter a number for ' + label + ', or 0 to switch that part off.' };
      var n = parseInt(raw, 10);
      if (!isFinite(n) || n < 0 || n > max) return { error: label + ' must be a whole number from 0 to ' + max + '.' };
      return { value: n };
    }

    function render(config) {
      var c = config || {};
      enabled.checked = c.enabled !== false;
      fold.value = (c.foldWindowMinutes === undefined || c.foldWindowMinutes === null) ? '' : String(c.foldWindowMinutes);
      join.value = (c.joinWindowDays === undefined || c.joinWindowDays === null) ? '' : String(c.joinWindowDays);
      /* CUSTOM_COLDOWNER_BY_CLAUDE (Ryan 2026-09-11) — Phase 4. Guarded because the two fields
         can be absent: this asset also serves a cached copy of the snippet from before they
         existed, and a null deref here would take the whole panel's load with it. */
      if (coldOn) coldOn.checked = c.coldOwnerEnabled !== false;
      if (coldDays) coldDays.value = (c.coldOwnerDays === undefined || c.coldOwnerDays === null) ? '' : String(c.coldOwnerDays);
    }

    function describe(c) {
      if (!c || c.enabled === false) {
        return 'Saved — the rule is off. Every submission goes back through the territory and capacity cascade.';
      }
      var parts = [];
      parts.push(c.foldWindowMinutes > 0
        ? 'an identical repeat inside ' + c.foldWindowMinutes + ' minute' + (c.foldWindowMinutes === 1 ? '' : 's') + ' is absorbed'
        : 'nothing is absorbed');
      parts.push(c.joinWindowDays > 0
        ? 'a repeat inside ' + c.joinWindowDays + ' day' + (c.joinWindowDays === 1 ? '' : 's') + ' is grouped and takes no capacity slot'
        : 'every repeat takes its own capacity slot');
      /* ⛔ THE COLD SENTENCE IS APPENDED, NEVER FOLDED INTO THE LIST ABOVE. Those two describe
         what happens to an incoming submission; this describes a view. Reading as one sentence
         would suggest the flag routes something, which is the one thing it must never imply. */
      var out = 'Saved — ' + parts.join(', and ') + '.';
      if (coldOn && coldDays) {
        out += coldOn.checked
          ? ' Deals nobody has worked in ' + (parseInt(coldDays.value, 10) || 0) + ' days are flagged Cold on the board.'
          : ' The Cold flag is off.';
      }
      return out;
    }

    (async function load() {
      try {
        var data = await window.RepPortal.API.get('/admin/deal-identity-config');
        if (data && data.config) render(data.config);
        else showMsg(msg, 'Could not read the current settings — nothing has been changed.', 'error');
      } catch (e) {
        showMsg(msg, 'Could not read the current settings: ' + (e && e.message ? e.message : 'request failed'), 'error');
      }
    })();

    btn.addEventListener('click', async function() {
      hideMsg(msg);
      var f = readWindow(fold, 720, 'the absorb window');
      if (f.error) { showMsg(msg, f.error, 'error'); return; }
      var j = readWindow(join, 365, 'the same-deal window');
      if (j.error) { showMsg(msg, j.error, 'error'); return; }
      /* ⚠️ A FLOOR OF 7, NOT 0. The two windows above take 0 as "switch that tier off"; a cold
         window of 0 would flag every open deal on the board, which is not an off switch. The
         checkbox is the off switch, and the worker clamps to the same floor. */
      var cd = null;
      if (coldOn && coldDays) {
        cd = readWindow(coldDays, 365, 'the cold-deal window');
        if (cd.error) { showMsg(msg, cd.error, 'error'); return; }
        if (cd.value < 7) { showMsg(msg, 'The cold-deal window must be at least 7 days — untick the box to switch it off instead.', 'error'); return; }
      }

      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Saving...';
      try {
        var res = await window.RepPortal.API.post('/admin/deal-identity-config', {
          enabled: !!enabled.checked,
          foldWindowMinutes: f.value,
          joinWindowDays: j.value,
          ...(cd ? { coldOwnerEnabled: !!coldOn.checked, coldOwnerDays: cd.value } : {}),
        });
        /* Re-render from what the WORKER stored, not from what was typed: it clamps both windows,
           so a value it changed must be the value on screen. */
        if (res && res.config) render(res.config);
        showMsg(msg, describe(res && res.config), 'success');
      } catch (e) {
        showMsg(msg, 'Save failed: ' + (e && e.message ? e.message : 'request failed'), 'error');
      } finally {
        btn.disabled = false;
        btn.textContent = orig;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDealIdentityPanel);
  } else {
    initDealIdentityPanel();
  }
})();
